export enum SettingType {
  YouTube = 'youtube',
  Twitter = 'x',
  LAN = 'lan',
  Yahoo = 'yahoo',
  Twitter_White = 'x_white'
}

export enum SettingState {
  ConsentRequired = 'consentRequired',
  Active = 'active',
  Inactive = 'inactive'
}

export enum YoutubeVideoVisibility {
  Public = 'public',
  Private = 'private',
  Unlisted = 'unlisted'
}
